<template>
  <div
    class="ui-switch"
    :class="{ 'isChecked': checked }"
  >
    <span class="ui-switch__core"
    :style="{ 'background': checked ? activeColor : inactiveColor, 
              'borderColor': checked ? activeColor : inactiveColor }"
    ></span>
  </div>
</template>
<script>
  export default {
    name: 'UiSwitch',
    props: {
      checked: [Boolean, Object, Array],
      activeColor: {
        type: String,
        default: '#409eff'
      },
      inactiveColor: {
        type: String,
        default: '#dcdfe6'
      }
    }
  };
</script>
<style lang="scss">
.ui-switch {
  &__core {
    margin: 0;
    display: inline-block;
    position: relative;
    width: 40px;
    height: 20px;
    border: 1px solid;
    outline: none;
    border-radius: 10px;
    box-sizing: border-box;
    cursor: pointer;
    transition: border-color .3s,background-color .3s;
    vertical-align: middle;

    &:after {
      content: "";
      position: absolute;
      top: 1px;
      left: 1px;
      border-radius: 100%;
      transition: all .3s;
      width: 16px;
      height: 16px;
      background-color: #fff;
    }
  }

  &.isChecked {
    .ui-switch {
      &__core {
        border-color: #409eff;
        background-color: #409eff;

        &:after {
          left: 100%;
          margin-left: -17px;
        }
      }
    }
  }
}
</style>